
{
  "familyId": "SWW-VD-ZONDER-GE",
  "questions": [
    {
      "id": "SWW-VD-ZONDER-GE-001",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'vertellen'?",
      "context": "Op het schoolplein hoort Sara haar vriendin verhalen: 'Wat heeft Mees jou allemaal ___?'",
      "options": ["verteld", "geverteld", "vertelt", "vertelde"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD zonder ge- (BEVO-HEG)", "content": "Werkwoorden die beginnen met be-, ver-, ont-, her-, ge- of er- krijgen GEEN extra ge- in het voltooid deelwoord. Ezelsbruggetje: BEVO-HEG. Vertellen → verteld (niet geverteld).", "icon": "lightbulb"}}],
      "conceptId": "vd_ver_prefix",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Pas de BEVO-HEG-regel toe: 'vertellen' begint met ver- → geen extra ge-. Daarna kofschip-check: stam = 'vertel', laatste letter 'l' staat NIET in 't kofschip → uitgang -d. Stam + d = verteld. Checkstrategie: zeg hardop 'geverteld' — dat klinkt onnatuurlijk → bevestigt: geen ge-.",
        "solutionSteps": [
          "Stap 1 — BEVO-HEG: vertellen begint met ver- → GEEN extra ge-",
          "Stap 2 — Stam bepalen: vertellen → vertel",
          "Stap 3 — Kofschip-check: 'l' niet in 't kofschip → +d",
          "Stap 4 — Aaneenplakken: vertel + d = verteld",
          "Check: 'geverteld' klinkt fout → bevestigt geen ge-"
        ],
        "distractorExplanations": {
          "0": "Goed! Vertellen → verteld (ver- = geen ge-, kofschip → -d).",
          "1": "Je dacht waarschijnlijk dat elk VD met ge- begint. Maar werkwoorden met ver-, be-, ont-, her-, ge- of er- (BEVO-HEG) krijgen geen extra ge-. Onthoud: ver-tel-d, niet ge-ver-teld.",
          "2": "Je hebt de tegenwoordige tijd geschreven (hij vertelt). Het voltooid deelwoord is verteld (met -d, niet -t aan het eind). Onthoud: VD = stam + d/t volgens kofschip.",
          "3": "Je hebt de verleden tijd geschreven (hij vertelde). Het voltooid deelwoord is verteld (zonder -e). Onthoud: VD = stam + d/t, VT = stam + de/te."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "sww.vd-ge-toegevoegd", "label": "Standaard ge- toegevoegd ondanks BEVO-HEG-voorvoegsel", "optionIndex": 1 },
          { "id": "sww.vd-tegenwoordige-tijd", "label": "Tegenwoordige tijd verward met VD", "optionIndex": 2 },
          { "id": "sww.vd-verleden-tijd", "label": "Verleden tijd (stam + de) verward met VD (stam + d)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-002",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "multiple_choice",
      "question": "Welk werkwoord krijgt WEL ge- in het voltooid deelwoord?",
      "context": "Tijdens een spelletje 'spelletjes-quiz' moet je voor elk werkwoord beslissen of het VD met ge- begint.",
      "options": ["werken → gewerkt", "bezoeken → bezocht", "ontdekken → ontdekt", "vergeten → vergeten"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": { "title": "Voorvoegsels zonder ge- (BEVO-HEG)", "content": "be-, ver-, ont-, her-, er-, ge- → geen extra ge- in het VD", "icon": "lightbulb" }
        }
      ],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Wanneer wel ge-?", "content": "Alleen werkwoorden die NIET beginnen met BEVO-HEG (be-, ver-, ont-, her-, er-, ge-) krijgen ge- in het VD. 'Werken' begint met 'w', dus wel ge-: gewerkt. Check: zeg 'gewerkt' en 'werkt' — 'werkt' alleen klinkt onaf → bevestigt: wél ge-.", "icon": "lightbulb"}}],
      "conceptId": "vd_wel_ge",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "BEVO-HEG-regel toepassen: alleen werkwoorden die NIET met be-/ver-/ont-/her-/er-/ge- beginnen krijgen ge- in het VD. 'Werken' begint met 'w' → wél ge- → gewerkt. De andere drie beginnen met be-, ont- of ver- → geen ge-. Checkstrategie: zet het in een zin met 'ik heb': 'ik heb gewerkt' ✓ klinkt natuurlijk; 'ik heb gebezocht' ✗ klinkt fout.",
        "solutionSteps": [
          "Stap 1 — Voor elk werkwoord BEVO-HEG-check doen",
          "Werken begint met 'w' → NIET in BEVO-HEG → wel ge- → gewerkt ✓",
          "Bezoeken (be-), ontdekken (ont-), vergeten (ver-) → wel BEVO-HEG → geen ge-",
          "Check: 'ik heb gewerkt' klinkt natuurlijk; 'ik heb gebezocht' niet"
        ],
        "distractorExplanations": {
          "0": "Goed! Werken → gewerkt (begint niet met BEVO-HEG-voorvoegsel).",
          "1": "Je dacht waarschijnlijk dat 'bezoeken' ge- krijgt. Maar bezoeken begint met be-, en werkwoorden met be- krijgen geen ge-. Onthoud: het VD is bezocht, niet gebezocht.",
          "2": "Je dacht waarschijnlijk dat 'ontdekken' ge- krijgt. Maar ontdekken begint met ont-, en werkwoorden met ont- krijgen geen ge-. Onthoud: het VD is ontdekt, niet geontdekt.",
          "3": "Je dacht waarschijnlijk dat 'vergeten' ge- krijgt. Maar vergeten begint met ver-, en werkwoorden met ver- krijgen geen ge-. Onthoud: het VD is vergeten, niet gevergeten."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.vd-bevoheg-niet-herkend", "label": "BEVO-HEG-voorvoegsel niet herkend in 'bezoeken'", "optionIndex": 1 },
          { "id": "sww.vd-bevoheg-niet-herkend", "label": "BEVO-HEG-voorvoegsel niet herkend in 'ontdekken'", "optionIndex": 2 },
          { "id": "sww.vd-bevoheg-niet-herkend", "label": "BEVO-HEG-voorvoegsel niet herkend in 'vergeten'", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-003",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'beloven'?",
      "context": "In zijn dagboek schrijft Tim: 'Vandaag heb ik mama ___ om mijn kamer op te ruimen.'",
      "options": ["beloofd", "gebeloofd", "belooft", "beloven"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD met be-", "content": "Beloven begint met be- (BEVO-HEG) → geen ge-. Voor de kofschip-keuze kijk je naar de letter vóór -en in het hele werkwoord: belov-en → 'v' staat NIET in 't kofschip → +d. Het VD is 'beloofd'. Checkstrategie: 'ik heb beloofd' ✓ vs. 'ik heb gebeloofd' ✗.", "icon": "lightbulb"}}],
      "conceptId": "vd_be_prefix",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "BEVO-HEG-regel: 'beloven' begint met be- → geen ge-. Voor kofschip-check kijk je naar de letter vóór -en in het hele werkwoord: belov-en → de 'v' staat NIET in 't kofschip → +d. Stam is 'beloof' (v→f aan einde stam). Antwoord: beloofd. Checkstrategie: zeg 'ik heb beloofd' hardop — klinkt goed. 'Ik heb gebeloofd' klinkt fout → bevestigt: geen ge-.",
        "solutionSteps": [
          "Stap 1 — BEVO-HEG: beloven begint met be- → geen ge-",
          "Stap 2 — Kijk naar hele werkwoord: belov-en → letter vóór -en = v",
          "Stap 3 — Kofschip-check: 'v' niet in kofschip → +d",
          "Stap 4 — Stam met v→f: beloof + d = beloofd",
          "Check: 'ik heb beloofd' klinkt natuurlijk"
        ],
        "distractorExplanations": {
          "0": "Goed! Beloven → beloofd (be- = geen ge-, v niet in kofschip → +d).",
          "1": "Je dacht waarschijnlijk dat elk VD met ge- begint. Maar beloven begint met be- (BEVO-HEG), dus geen ge-. Onthoud: be-, ver-, ont-, her-, er-, ge- = geen extra ge-.",
          "2": "Je hebt de tegenwoordige tijd geschreven (hij belooft). Het VD is beloofd (met -d, niet -t). Onthoud: VD ≠ tegenwoordige tijd.",
          "3": "Je hebt de infinitief geschreven (beloven). Het VD is beloofd. Onthoud: het VD is een andere vorm dan het hele werkwoord."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "sww.vd-ge-toegevoegd", "label": "Standaard ge- toegevoegd ondanks BEVO-HEG-voorvoegsel", "optionIndex": 1 },
          { "id": "sww.vd-tegenwoordige-tijd", "label": "Tegenwoordige tijd verward met VD", "optionIndex": 2 },
          { "id": "sww.vd-infinitief-gebruikt", "label": "Infinitief gebruikt in plaats van VD", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-004",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'herstellen'?",
      "context": "De monteur belt: 'Ik heb je fiets ___ — je kunt hem ophalen.'",
      "options": ["hersteld", "gehersteld", "herstelt", "herstelde"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD met her- (BEVO-HEG)", "content": "Herstellen begint met her- (BEVO-HEG) → geen ge-. Stam = herstel. L niet in kofschip → +d. VD = hersteld. Checkstrategie: 'ik heb hersteld' ✓ klinkt natuurlijk.", "icon": "lightbulb"}}],
      "conceptId": "vd_her_prefix",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "BEVO-HEG-regel: 'herstellen' begint met her- → geen ge-. Stam = herstel. Kofschip-check: 'l' niet in 't kofschip → +d. Stam + d = hersteld. Checkstrategie: lees hardop 'ik heb hersteld' (goed) vs. 'ik heb gehersteld' (fout) — bevestigt geen ge-.",
        "solutionSteps": [
          "Stap 1 — BEVO-HEG: herstellen begint met her- → GEEN ge-",
          "Stap 2 — Stam bepalen: herstellen → herstel",
          "Stap 3 — Kofschip-check: 'l' niet in 't kofschip → +d",
          "Stap 4 — Aaneenplakken: herstel + d = hersteld",
          "Check: 'ik heb hersteld' klinkt natuurlijk"
        ],
        "distractorExplanations": {
          "0": "Goed! Herstellen → hersteld (her- = geen ge-).",
          "1": "Je dacht waarschijnlijk dat elk VD met ge- begint. Maar her- is een van de BEVO-HEG-voorvoegsels waardoor je geen ge- toevoegt. Onthoud: be-, ver-, ont-, her-, er-, ge- = geen ge-.",
          "2": "Je hebt de tegenwoordige tijd geschreven (hij herstelt). Het VD is hersteld (met -d, niet -t). Onthoud: VD = stam + d/t.",
          "3": "Je hebt de verleden tijd geschreven (hij herstelde). Het voltooid deelwoord is hersteld (zonder -e). Onthoud: VD = stam + d/t, VT = stam + de/te."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "sww.vd-ge-toegevoegd", "label": "Standaard ge- toegevoegd ondanks BEVO-HEG-voorvoegsel", "optionIndex": 1 },
          { "id": "sww.vd-tegenwoordige-tijd", "label": "Tegenwoordige tijd verward met VD", "optionIndex": 2 },
          { "id": "sww.vd-verleden-tijd", "label": "Verleden tijd verward met VD", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-005",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "fill_in",
      "question": "Vul het voltooid deelwoord in: De brief is ... (bezorgen).",
      "options": [],
      "correctAnswer": "bezorgd",
      "data": {
        "acceptedAnswers": ["bezorgd"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD van bezorgen", "content": "Bezorgen begint met be- (BEVO-HEG) → geen ge-. Stam = bezorg. G niet in kofschip → +d. VD = bezorgd.", "icon": "lightbulb"}}],
      "conceptId": "vd_be_prefix_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "BEVO-HEG: bezorgen begint met be- → geen ge-. Stam = bezorg. Kofschip-check: 'g' niet in 't kofschip → +d. Stam + d = bezorgd. Check: 'de brief is bezorgd' klinkt goed.",
        "solutionSteps": [
          "Stap 1 — BEVO-HEG: be- → geen ge-",
          "Stap 2 — Stam = bezorg",
          "Stap 3 — Kofschip: 'g' niet in kofschip → +d",
          "Stap 4 — bezorg + d = bezorgd"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application"
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-006",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "sentence_error_judge",
      "question": "In welke zin staat een fout bij het voltooid deelwoord? Klik op de fout.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "Hij heeft het verhaal geverteld.", "hasError": true, "correction": "verteld", "explanation": "'Vertellen' begint met ver- (BEVO-HEG) → geen ge-. Het VD is 'verteld', niet 'geverteld'." },
          { "text": "Zij heeft het pakket bezorgd.", "hasError": false },
          { "text": "Wij hebben het huis hersteld.", "hasError": false },
          { "text": "Ik heb het boek gelezen.", "hasError": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "BEVO-HEG: geen ge-", "content": "Werkwoorden met be-, ver-, ont-, her-, er- of ge- krijgen GEEN extra ge- in het VD. 'Vertellen' → verteld (niet geverteld). 'Bezorgen' → bezorgd. 'Herstellen' → hersteld.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_zonder_ge_error",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "BEVO-HEG-check op elke zin: 'geverteld' is fout — 'vertellen' begint met ver- → geen ge- → verteld. De andere zinnen zijn correct: bezorgd (be-), hersteld (her-), gelezen (lezen begint niet met BEVO-HEG → wel ge-).",
        "solutionSteps": [
          "Stap 1 — Voor elke zin: BEVO-HEG-check op het werkwoord",
          "Geverteld → vertellen heeft ver- → fout, moet verteld zijn",
          "Bezorgd → bezorgen heeft be- → correct (geen ge-)",
          "Hersteld → herstellen heeft her- → correct (geen ge-)",
          "Gelezen → lezen heeft geen BEVO-HEG → correct (wél ge-)"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis"
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-007",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "categorize",
      "question": "Sorteer deze werkwoorden: krijgt het VD wél of géén ge-?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Wél ge- in VD", "Géén ge- in VD"],
        "items": [
          { "text": "werken → gewerkt", "correctCategory": 0 },
          { "text": "vertellen → verteld", "correctCategory": 1 },
          { "text": "fietsen → gefietst", "correctCategory": 0 },
          { "text": "beloven → beloofd", "correctCategory": 1 },
          { "text": "koken → gekookt", "correctCategory": 0 },
          { "text": "ontdekken → ontdekt", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Wel of geen ge-?", "content": "Werkwoorden met be-, ver-, ont-, her-, er- of ge- (BEVO-HEG) krijgen GEEN ge-. Alle andere werkwoorden krijgen WEL ge-. Werken → gewerkt ✓. Vertellen (ver-) → verteld ✓.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_ge_categorize",
      "variantIndex": 7,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "BEVO-HEG-regel: werkwoorden die beginnen met be-, ver-, ont-, her-, er- of ge- krijgen GEEN extra ge- in het VD. Waarom? Deze voorvoegsels zijn al onbeklemtoond — net als ge-. Twee onbeklemtoonde voorvoegsels achter elkaar klinkt niet in het Nederlands. Checkstrategie: zeg het VD hardop met én zonder ge-. 'Geverteld' klinkt onnatuurlijk → geen ge-. 'Werkt' alleen klinkt onaf → wél ge- → gewerkt.",
        "solutionSteps": [
          "Stap 1 — Kijk naar het begin van het werkwoord — staat er be-, ver-, ont-, her-, er- of ge-?",
          "Stap 2a — Ja (vertellen=ver-, beloven=be-, ontdekken=ont-) → GEEN ge- in het VD",
          "Stap 2b — Nee (werken, fietsen, koken) → WÉL ge- in het VD",
          "Stap 3 — Check door hardop te zeggen: 'geverteld' klinkt fout ✗ → verteld ✓",
          "Ezelsbruggetje: BEVO-HEG (be-, ver-, ont-, her-, er-, ge-) = geen extra ge-"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis"
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-008",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "drag_drop_fill",
      "question": "Sleep het juiste voltooid deelwoord naar de juiste zin.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "template": "Hij heeft het verhaal {0}.\nZij heeft een cadeau {1}.\nWij hebben het huis {2}.",
        "draggables": ["verteld", "gekocht", "hersteld", "geverteld", "gehersteld"],
        "correctPlacements": { "0": 0, "1": 1, "2": 2 }
      },
      "stimulusAids": [
        {
          "type": "rule",
          "data": { "title": "Voorvoegsels zonder ge- (BEVO-HEG)", "content": "be-, ver-, ont-, her-, er-, ge- → geen extra ge- in het VD. Andere werkwoorden → wél ge-.", "icon": "lightbulb" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "VD zonder ge-",
            "content": "Vertellen (ver-) → verteld (niet geverteld). Herstellen (her-) → hersteld (niet gehersteld). Kopen (geen voorvoegsel) → gekocht (wél ge-).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vd_zonder_ge_drag_drop",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "BEVO-HEG-check op elk werkwoord: 'vertellen' (ver-) → geen ge- → verteld. 'Kopen' (geen BEVO-HEG) → wél ge- → gekocht. 'Herstellen' (her-) → geen ge- → hersteld. De afleidersopties 'geverteld' en 'gehersteld' zijn fout omdat ver- en her- al BEVO-HEG-voorvoegsels zijn.",
        "solutionSteps": [
          "Stap 1 — Vertellen (ver-) → geen ge- → verteld ✓",
          "Stap 2 — Kopen (geen BEVO-HEG) → wél ge- → gekocht ✓",
          "Stap 3 — Herstellen (her-) → geen ge- → hersteld ✓",
          "Geverteld en gehersteld zijn fout: ver- en her- = geen extra ge-"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application"
      }
    }
  ]
}
